import { DescriptionText, SpanPolitics } from 'components/birthday-input/style.custom'
import { Link } from 'react-router-dom'

const Arrow = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 0.46875C12.3392 0.46875 14.0482 0.932617 15.627 1.86035C17.1569 2.75553 18.3695 3.9681 19.2646 5.49805C20.1924 7.07682 20.6562 8.78581 20.6562 10.625C20.6562 12.4642 20.1924 14.1732 19.2646 15.752C18.3695 17.2819 17.1569 18.4945 15.627 19.3896C14.0482 20.3174 12.3392 20.7812 10.5 20.7812C8.66081 20.7812 6.95182 20.3174 5.37305 19.3896C3.8431 18.4945 2.63053 17.2819 1.73535 15.752C0.807617 14.1732 0.34375 12.4642 0.34375 10.625C0.34375 8.78581 0.807617 7.07682 1.73535 5.49805C2.63053 3.9681 3.8431 2.75553 5.37305 1.86035C6.95182 0.932617 8.66081 0.46875 10.5 0.46875ZM10.5 2.03125C8.9375 2.03125 7.48893 2.42188 6.1543 3.20312C4.86849 3.9681 3.8431 4.99349 3.07812 6.2793C2.29688 7.61393 1.90625 9.0625 1.90625 10.625C1.90625 12.1875 2.29688 13.6361 3.07812 14.9707C3.8431 16.2565 4.86849 17.2819 6.1543 18.0469C7.48893 18.8281 8.9375 19.2188 10.5 19.2188C12.0625 19.2188 13.5111 18.8281 14.8457 18.0469C16.1315 17.2819 17.1569 16.2565 17.9219 14.9707C18.7031 13.6361 19.0938 12.1875 19.0938 10.625C19.0938 9.0625 18.7031 7.61393 17.9219 6.2793C17.1569 4.99349 16.1315 3.9681 14.8457 3.20312C13.5111 2.42188 12.0625 2.03125 10.5 2.03125ZM11.0615 5.62012L16.0664 10.625L11.0615 15.6299L9.93848 14.5312L13.0635 11.4062H5.03125V9.84375H13.0635L9.93848 6.71875L11.0615 5.62012Z" fill="#FF2B00" />
    </svg>
  )
}

export const languageES = {
  legalage: {
    title: ' ',
    button1: <span style={{ fontSize: '14px' }}>SI, SOY MAYOR</span>,
    button2: <span style={{ fontSize: '14px' }}>NO, SOY MENOR</span>,
    question: '¿Eres mayor de edad?'
  },
  agegate: {
    title: <span className='invisible'></span>,
    description: <div className='flex flex-col justify-between items-center gap-5 flex-1'>
      <img src={`${AZURE_BASE_URL}/agegate.webp`} alt="Titulo" className='w-full mx-auto' style={{ maxWidth: '277.28px' }} />
      <DescriptionText className='normal-case mx-7 text-center helvetica text-sm font-normal agegate__description'>
        <span>¡Bienvenido!</span> <br />
        ¿ERES MAYOR DE EDAD?
      </DescriptionText>
    </div>,
    politics1: <span className='hidden'></span>,
    politics2: <SpanPolitics className='agegate__politics text-white' style={{ fontFamily: "Montserrat" }}>
      AL CONFIRMAR, ACEPTAS LA <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">POLÍTICA DE PRIVACIDAD</a >, <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">TÉRMINOS Y CONDICIONES Y USO DE COOKIES</a > DE ESTE SITIO WEB. ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, LEE NUESTRA POLÍTICA DE <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">PRIVACIDAD</a > Y USO DE <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">COOKIES</a >.
    </SpanPolitics>,
    button: (
      <div className='relative flex justify-center items-center' style={{ height: '50px' }}>
        <span className='z-20'>CONTINUAR</span>
        {/* <img src={`${AZURE_BASE_URL}/btn-style-1.webp`} alt="button" className='absolute top-1 left-0' /> */}
      </div>
    )
  },
  signup: {
    title: 'Bienvenido',
    description:
      'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.',
    button: 'SIGUIENTE',
    welcome: {
      title: <>¡BIENVENIDO, nombre!</>,
      subtitle: 'Solo falta validar tu cuenta.',
      description: <>Te enviamos un código de 6 dígitos a tu correo electrónico para que valides.</>,
      description3: <b>¿No lo recibiste?</b>,
      button: 'SIGUIENTE',
      otp: {
        title: 'Ingresa el código de 6 dígitos que recibiste para verificar tu correo.'
      }
    }
  },
  start: {
    signup: 'REGÍSTRATE CON CORREO',
    signin: 'INGRESA CON CORREO',
    social: 'Ingresa con:',
    title: {
      html: (
        <div className="flex-1 w-full pb-2 flex flex-col items-center">
          <img src={`${AZURE_BASE_URL}/fondo-inicial.webp`} alt="background" className="w-full" />
        </div>
      )
    }
  },
  home: {
    title: '¿Qué quieres hacer?',
    description: '¡Completa tus datos!',
    popup: {
      two: {
        mobile: `${AZURE_BASE_URL}/popup-6.webp`,
        desktop: `${AZURE_BASE_URL}/popup-6.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popup-6.webp`
      },
      six: {
        mobile: `${AZURE_BASE_URL}/popup-6.webp`,
        desktop: `${AZURE_BASE_URL}/popup-6.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popup-6.webp`
      }
    }
  },
  password: {
    title: 'Resetear contraseña',
    label: {
      newPassword: 'Nueva Contraseña',
      newPasswordConfirm: 'Repetir Nueva Contraseña'
    }
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿Cómo te llamas?',
          placeholder: 'Escribe aquí tu nombre'
        },
        lastname: {
          placeholder: 'Escribe aquí tu apellido'
        },
        nickname: {
          label: 'Tu apodo (opcional)',
          placeholder: 'Escribe aquí tu apodo'
        },
        gender: {
          label: '¿Cómo te identificas?',
          placeholder: 'Selecciona una opción'
        },
        email: {
          label: 'Correo electrónico'
        }
      }
    },
    information: 'Datos personales',
    address: 'Dirección',
    contact: 'Contacto',
    button: 'IR A VER LOS PREMIOS',
    state: 'Mis premios',
    stateLabel: 'Mis premios',
    identification: {
      button: 'DESCARGAR ID',
      label: 'Mi SOL MEZCLAS ID',
      nav: 'Mi SOL MEZCLAS ID'
    },
    view: {
      arrow: <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.96094 0.0859375L8.03906 1.16406L2.95312 6.25H18V7.75H2.95312L8.03906 12.8359L6.96094 13.9141L0.585938 7.53906L0.0703125 7L0.585938 6.46094L6.96094 0.0859375Z" fill="#BBBCBD" />
      </svg>
    },
    stateNotFound: <span className='text-sm'>Aún no has ganado ningún premio.</span>,
    ranking: {
      title: 'TUS PUNTOS ACUMULADOS',
      box: {
        one: 'TUS PUNTOS:',
        two: 'TU POSICIÓN:'
      },
      discover: <div className='rank-box__discover'><p>¡Se antoja subir en el ranking!<br />Descubre tus puntos</p></div>,
      firstPlace: <div className='rank-box__first-place'><p>¡estás en el <span className='rank-box__first-place__rest'>1er puesto</span>!<br /><span className='rank-box__first-place__bottom'>Se antoja quedarse ahí, sigue participando</span></p></div>,
      positionTwo: <div className='rank-box__text'><p>¡Se antoja el siguiente puesto!<br />Te faltan <span className='rank-box__text__rest'>POINTS</span> PUNTOS para avanzar</p></div>,
      text: <>¡Las personas que acumulen más puntos y queden en los primeros 5 puestos del ranking ganarán premios de antojo al finalizar la promoción!</>
    },
    prize: {
      detail: {
        description: <>Tu cupón Uber Eats vale por una muestra gratis de Sol Mezclas Clamato. Actívalo dando clic a “Redimir Premio” que elevará a la app de Uber Eats.</>
      }
    }
  },
  config: {
    prizes: '/album/redirect/Tickets/upload'
  },
  congrats: {
    range: {
      title: 'NUEVO LOGRO DESBLOQUEADO',
      description: <></>,
      description2: (
        <>
          Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.
        </>
      )
    }
  },
  login: {
    recovery: {
      sent: '¿Olvidaste tu contraseña?'
    },
    button: 'Ingresar'
  },
  endroute: {
    title: (
      <>
        ¡Lo sentimos!<br />Esto es sólo para mayores de edad
      </>
    ),
    description: 'Vuelve cuando sea más grande.'
  },
  referrals: {
    description: 'Comparte tu código con amigos y gana más oportunidades de ganar.',
    subtitle: 'COMPARTE TU CÓDIGO Y GANA',
    left: 'COPIAR',
    right: 'COMPARTIR'
  },
  trivias: {
    'not-found': <>No hay trivias disponibles por el momento, <br /> estate atento a nuestras nuevas dinámicas.</>,
    exchange: {
      button: {
        text: 'COMPLETAR MIS DATOS',
        url: '/profile'
      }
    },
    triviaQr: {
      register: {
        title: (
          <div className="text-white antonio">
            CONTESTA Y GANA
          </div>
        ),
        description: (
          <div className="text-white">
            <p>¿Ya tienes tu CRISTAL ID?</p>
            <b className="mt-3">SI NO LO TIENES CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</b>
            <img
              className="mx-auto mt-5"
              src="https://promohubstorage.blob.core.windows.net/cristal/assets/crista_id_ej.svg"
            />
          </div>
        ),
        html: (
          <>
            <div className="flex-1 flex-col gap-6 w-full flex px-7 items-center justify-center text-center">
              <h1 className="antonio text-4xl font-bold text-white">
                CONTESTA Y GANA
              </h1>
              <p className='helvetica text-base text-white font-bold'>¿Ya tienes tu ID?</p>
              <p className='helvetica text-base text-white font-normal'>Si no lo tienes córrele a registrarte para poder participar.</p>
            </div>
            <img src={`${AZURE_BASE_URL}/trivia-qr-footer.png`} />
          </>
        )
      },
      late: {
        title: (
          <>
            NO DISPONIBLE
          </>
        ),
        description: <p className="text-white">Lamentablemente esta trivia ya no está disponible. Estate atento para contestar otra.</p>,
        button: {
          text: 'VER MÁS TRIVIAS'
        }
      }
    },
    questions1: <>Contesta </>,
    questions2: (
      <>
        {' '}
        <span className="font-bold">
          preguntas
        </span>{' '}
        sobre el tema y gana:
      </>
    ),
    exit: {
      accept: "Si, claro",
      cancel: "No, volver",
      subtitle: 'Si cancelas ahora se perderá tu progreso y tendrás que volver a empezar.'
    }
  },
  tivias: {
    challenge: {
      modal: {
        description: <>¿Segurísimo que quieres empezar a jugar? <br />una vez que des click no hay vuelta atrás.</>
      }
    }
  },
  survey: {
    title: 'CUÉNTANOS DE TI',
    button: 'RESPONDER'
  },
  mail: {
    description: (
      <>
        Has confirmado con éxito tu cuenta. <br /> Ya puedes ingresar.
      </>
    ),
    title: <>¡Excelente name!</>
  },
  prizes: {
    start: {
      title: <span style={{ fontFamily: 'Antonio', fontWeight: 500, fontSize: '24px' }}>PREMIOS</span>
    },
    description: {
      politic: <>Recuerda que debes tener tus datos actualizados para poder ganar</>
    },
    congrats: {
      description: <>Ahora atentx al mail que te vamos a mandar con toda la info del envío de tu canje<br />¡Felicidades!</>
    }
  },
  popUps: {
    start: {
      html: (
        <div className="flex-1 flex flex-col gap-4 items-center pt-5">
          <h1 className="font-semibold text-3xl antonio uppercase mb-3">¿Cómo participar?</h1>
          <ul className="flex-1 items-center flex-col flex w-full gap-6 mb-6">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/start-popup-1.svg`} />
              <div className="flex-1 flex flex-col justify-center gap-2">
                <p className="font-bold text-lg antonio leading-4" style={{ color: '#E30613' }}>
                  Regístrate.
                </p>
                <p className="font-normal text-sm helvetica" style={{ color: '#00A7B5', lineHeight: '120%' }}>
                  Completa tus datos para empezar a juntar Silver Stars.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/start-popup-3.svg`} />
              <div className="flex-1 flex flex-col justify-center gap-2">
                <p className="font-bold text-lg antonio leading-4" style={{ color: '#E30613' }}>
                  Participa.
                </p>
                <p className="font-normal text-sm helvetica" style={{ color: '#00A7B5', lineHeight: '120%' }}>
                  Escanea los QRs de los Totems para participar en las dinámicas y juntar Silver Stars.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/start-popup-2.svg`} />
              <div className="flex-1 flex flex-col justify-center gap-2">
                <p className="font-bold text-lg antonio leading-4" style={{ color: '#E30613' }}>
                  Gana.
                </p>
                <p className="font-normal text-sm helvetica" style={{ color: '#00A7B5', lineHeight: '120%' }}>
                  Acumula tus Silver Stars en el menor tiempo posible y participa por grandes premios.
                </p>
              </div>
            </li>
          </ul>
        </div>
      )
    }
  },
  album: {
    title: 'Dinámicas',
    states: {
      all: 'TODOS',
      progress: 'ACTUALES',
      completed: 'PASADOS'
    },
    notFound: 'No hay retos disponibles por el momento, estate atento a nuestras nuevas dinámicas.'
  },
  social: {
    loader: {
      title: 'Estamos validando',
    },
    imgUpload: 'Espera mientras revisamos tu contenido.',
    Ticket: {
      howToParticipate: {
        title: '¿Cómo participar?',
        subtitle: 'SUBE TU RECIBO Y GANA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-1.svg`} className='object-top' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="" style={{ fontFamily: 'PT Sans', color: 'white', fontSize: '16px' }}>
                  <b>Completa tus datos</b> personales en el perfil de tu cuenta.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-2.svg`} className='object-top' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="" style={{ fontFamily: 'PT Sans', color: 'white', fontSize: '16px' }}>
                  <b>Sube una foto de tu recibo</b> donde se vea bien el detalle de tu compra de productos Heineken.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-3.svg`} className='object-top' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="" style={{ fontFamily: 'PT Sans', color: 'white', fontSize: '16px' }}>
                  <b>Acumula recibos</b><br />Los ganadores* serán aquellos que más tickets suban en el tiempo de duración de la dinámica. Para empezar a participar tienes que cargar como mínimo 3 tickets.<br /><br /><span style={{ fontSize: '10px' }}>* stock de premios: 300 unidades.</span>
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    El ticket debe ser de productos Heineken en alguna de sus presentaciones (Original, Light o 0.0).
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    Se debe visualizar la fecha de compra.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    No se debe cargar un ticket repetido.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    El recibo tiene que tener al menos 1 (un) producto Heineken para ser válido, ya sea Original, Light o 0.0.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    Podrás cargar tickets desde el 2 abril al 1ro de junio inclusive.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="">
                    Los ganadores serán aquellos usuarios que más recibos hayan subido en el tiempo que dure la dinámica, siempre y cuando hayan subido por lo menos 3 tickets.
                  </p>
                </div>
              </div>

            </>
          )
        }
      },
      upload: {
        title: 'Cargar imagen',
        subtitle: 'Clic para subir una imagen',
        howToTakePhotoText: 'Ver imagen de referencia',
        rules: {
          title: 'REGLAS PARA SUBIR CONTENIDO',
          list: (
            <ul style={{ color: '#1B4677', fontSize: '12px', fontFamily: 'PT Sans', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Usa la cámara de tu celular para tomarle una foto a tu recibo/ticket.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Busca un lugar iluminado para tomar la foto.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Mantente quieto al momento de tomar la foto para obtener una imagen de buena calidad.
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: 'Aún no puedes subir nuevo contenido por las siguientes razones:',
          list: <div style={{ width: '320px' }}>
            <div style={{ color: 'white' }} className="Montserrat text-sm font-normal">
              <p className='ml-5 mb-3'> • Llegaste al máximo de tickets que puedes cargar. (puedes subir máx. 3 veces al día)</p>
            </div>
          </div>,
          help: <div style={{ width: '320px', color: 'white' }} className='flex justify-center items-center flex-col mb-12 Montserrat pt-4'>
            <span className="font-bold text-center text-sm Montserrat">¿Te parece que no es así?</span>
            <span className="text-center text-sm Montserrat">Ponte en contacto con nosotros para que <br /> podamos ayudarte. <Link to="/help" className='underline'>Envíanos un mensaje.</Link> </span>
          </div>
        },
        icon: <svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
          <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
          <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
          <rect x="11.2036" y="43.019" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 43.019)" fill="#DA2B1F" />
          <rect x="11.2036" y="43.019" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 43.019)" fill="#DA2B1F" />
          <rect x="11.2036" y="43.019" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 43.019)" fill="#DA2B1F" />
        </svg>,
        isReady: '¿Está ok esta imagen?',
        'ranking-subtitle': {
          'progress': 'En esta galería puedes ver todas las imágenes creadas por los participantes.',
          'completed': 'Aquí puedes ver las frases ganadores del reto.'
        },
        howToTakePhoto: {
          title: 'Imagen de referencia',
          subtitle: 'Consejos para cargar el contenido:',
          "how-take-photo-img": "takePhotoImgModel.png",
          "how-take-photo-list": (
            <ul style={{ padding: 'revert', listStyle: 'disc' }}>
              <li className="pb-5">
                Busca un lugar bien iluminado para tomar la foto.
              </li>
              <li className="pb-5">

                Ubica el recibo sobre alguna superficie plana y deja el ticket lo más estirado y recto posible. Si es posible sobre un fondo limpio y sin otros elementos.
              </li>
              <li className="">
                Toma la foto asegurándote que se vean bien los artículos, la fecha y el lugar de compra.
              </li>
            </ul>
          )
        },
        buttonSubmit: 'Si, añadir'
      },
      congrats: {
        title: 'Eso ',
        description: <>GANASTE<br /><b className='uppercase'>Oportunidad para ganar gorra Heineken</b></>,
        button1: 'CARGAR OTRO RECIBO',
        button2Link: '/home',
        button2: 'VOLVER AL HOME'
      },
      config: {
        prizes: '/album/redirect/Ticket/upload'
      }
    },
  },
  error: {
    505: {
      title: '¡Qué pena!',
      description: <>Esa no era la respuesta correcta. <br /> Inténtalo nuevamente.</>,
      button: {
        link: '/trivias',
        text: 'VOLVER A EMPEZAR'
      }
    },
    10: {
      title: '¡UPS! el código OTP es inválido'
    },
    102: {
      title: <>¡UPS! TU TELÉFONO NO EXISTE EN SUMASIX</>,
      description: 'Recuerda que tienes que estar registrado con el mismo número de teléfono en SumaSix que el que usas para Sol Mezclas.',
      button: 'CAMBIAR MI NÚMERO DE TELÉFONO',
      subButton: 'XXX'
    },
    // 1303: {
    //   title: 'El celular ya existe en otra cuenta'
    // }
  },
  help: {
    title: '¿Más dudas?'
  },
  memorama: {
    list: {
      title: 'Memoramas',
      "not-found": "No hay memoramas disponibles por el momento, estate atento a nuestras nuevas dinámicas."
    },
    modal: {
      play: {
        description: <>Estás a punto de participar en este memorama y ganar: <br /></>,
        warning: <>¿Segurísimo que quieres empezar a jugar? <br /> una vez que des clic no hay vuelta atras.</>
      },
      title: <>MEMORAMA<br /><span className='memorama__list__how-to-participate__subtitle'>INSTRUCCIONES</span></>,
      items: (
        <div className='flex-1'>
          <div className="flex gap-4 items-center memorama__list__how-to-participate__item">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-1.webp`} alt="icons" className='memorama__list__how-to-participate__item__img' />
            <p className='flex-1 memorama__list__how-to-participate__item__text'>
              <b>Concéntrate y memoriza</b> el orden de las imágenes que van a aparecer.
            </p>
          </div>
          <div className="flex gap-4 items-center memorama__list__how-to-participate__item mt-5">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-2.webp`} alt="icons" className='memorama__list__how-to-participate__item__img' />
            <p className='flex-1 memorama__list__how-to-participate__item__text'>
              <b>Estas desaparecerán</b> y debes recordar el lugar donde estaban.
            </p>
          </div>
          <div className="flex gap-4 items-center memorama__list__how-to-participate__item mt-5">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-3.webp`} alt="icons" className='memorama__list__how-to-participate__item__img' />
            <p className='flex-1 memorama__list__how-to-participate__item__text'>
              <b>
                Si aciertas en todas, <br />
                ¡GANAS!
              </b>
            </p>
          </div>
        </div>
      ),
    },
  }
}